import { ITransactionActionType } from 'src/app/models/transactions';
import { EntityState } from '@ngrx/entity';
import { transactionTypeAdapter } from '../transactions/selectors/transaction-types.selector';
import { AccountType } from 'src/app/models/account';

export interface ITransactionTypesState extends EntityState<ITransactionActionType> {
    error: string;
    loading: boolean;
    selectedAccountType: AccountType;
    selectedCashType: ITransactionActionType;
    selectedRevenueType: ITransactionActionType;
    selectedSecurityType: ITransactionActionType;
}

export const initialTransactionTypesState = transactionTypeAdapter.getInitialState({
    error: '',
    loading: false,
    selectedAccountType: AccountType.Cash,
    selectedCashType: null,
    selectedRevenueType: null,
    selectedSecurityType: null,
});